// Module
var code = "<md-button ng-click=\"$ctrl.switch()\" class=\"save\" flex> <md-icon>send</md-icon> <span ng-disabled=\"$ctrl.isSwitchSubmitting\" ng-bind=\"$ctrl.isSwitchSubmitting ? 'Please wait ...' : 'Complete ' + ($ctrl.organizationCountry.cca2 === 'NZ' ? 'Refix' : 'Switch') + '/Post to commission'\"></span> </md-button> ";
// Exports
module.exports = code;